<template>
  <SocialsViewWrapper />
</template>

<script setup>
import { useRouter } from "vue-router";
import SocialsViewWrapper from "@follaw-fr/components/social-media/templates/SocialsViewWrapper.vue";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import { PermissionLevel } from "@/follaw-fr/constants/enums/permission-level.enum";

const userSettingsStore = useUserSettingsStore();
const router = useRouter();

// If you have access but got on this page manually, redirect to the overview
if (userSettingsStore.hasPermission(PermissionLevel.SOCIETAL)) {
  router.push("/twitter-overview");
}
</script>
